@if (store.selectedTable) {
  <div class="admin-import-module__section admin-import-module__section--wide">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="admin-import-module__preflight-head">
          <div class="admin-import-module__preflight-title">
            <h4 class="admin-import-module__card-title">{{ 'TRANS__IMPORT__PREFLIGHT_SECTION' | translate }}</h4>
            @if (store.preflightResult) {
              <span class="admin-import-module__preflight-subline">
                {{ 'TRANS__IMPORT__PREFLIGHT_RAN_WITH_CURRENT' | translate }}
              </span>
            }
          </div>
          <div class="admin-import-module__preflight-controls">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="admin-import-module__preflight-sample">
              <mat-label>{{ 'TRANS__IMPORT__PREFLIGHT_SAMPLE_SIZE' | translate }}</mat-label>
              @if (store.preflightWholeFile) {
                <input matInput type="number" class="admin-import-module__preflight-sample-all"
                       [value]="store.preflightSampleSize" disabled>
              } @else {
                <input matInput type="number" min="1" max="500"
                       [formControl]="store.preflightSampleSizeControl">
              }
            </mat-form-field>
            @if (store.preflightRangeFits) {
              <mat-checkbox [formControl]="store.preflightWholeFileControl" class="admin-import-module__preflight-whole-file">
                {{ (store.runRangeChosen ? 'TRANS__IMPORT__PREFLIGHT_WHOLE_RANGE' : 'TRANS__IMPORT__PREFLIGHT_WHOLE_FILE') | translate }}
              </mat-checkbox>
            }
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="admin-import-module__preflight-run"
              [disabled]="store.runningPreflight || store.uploading || !store.hasMappings || !!store.mediaJoinProblem"
              (click)="store.runPreflight()"
            >
              @if (store.runningPreflight) {
                <mat-progress-spinner matButtonIcon mode="indeterminate" diameter="18"></mat-progress-spinner>
              } @else {
                <mat-icon>refresh</mat-icon>
              }
              <span class="bold uppercase">
                {{ (store.preflightResult ? 'TRANS__IMPORT__PREFLIGHT_RERUN' : 'TRANS__IMPORT__PREFLIGHT_RUN') | translate }}
              </span>
            </button>
          </div>
        </div>

        @if (store.mediaJoinProblem; as problem) {
          <p class="admin-import-module__warn admin-import-module__preflight-blocked">{{ problem | translate }}</p>
        }

        @if (preflightRowRange; as range) {
          <p class="admin-import-module__hint admin-import-module__preflight-range">
            @let runSection = 'TRANS__IMPORT__RUN_SECTION' | translate;
            @if (range.last === null) {
              {{ 'TRANS__IMPORT__PREFLIGHT_ROW_RANGE_FROM' | translate: {first: range.first, section: runSection} }}
            } @else {
              {{ 'TRANS__IMPORT__PREFLIGHT_ROW_RANGE' | translate:
                 {first: range.first, last: range.last, section: runSection} }}
            }
          </p>
        }

        @if (store.preflightError) {
          <p class="admin-import-module__warn">{{ store.preflightError }}</p>
        }

        @if (store.preflightResult) {
          <app-import-preflight-result
            [preflightResult]="store.preflightResult"
            [mediaBlocksRun]="store.mediaBlocksRun"
            [mediaPatternMode]="store.mediaMatchModeControl.value === 'pattern'"
            [mediaJoinColumn]="store.mediaJoinColumnControl.value"
            [fileName]="store.fileName"
            [resolveLabel]="store.resolveConceptLabel"
            [resolveCardTitle]="store.cardListTitle"
            [resolveSubBlockTitle]="store.subBlockListTitle"
            [splitErrors]="store.preflightErrorSplit"
            [describeIncompleteCard]="store.incompleteCardText"
            [describeLackingRight]="store.lackingRightText"
            [rangeCount]="store.preflightResultRangeCount"
            (openView)="openView($event)"
          ></app-import-preflight-result>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <div class="admin-import-module__section admin-import-module__section--wide">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="admin-import-module__run-layout">
          <div class="admin-import-module__run-options">
            <h4 class="admin-import-module__card-title">{{ 'TRANS__IMPORT__RUN_SECTION' | translate }}</h4>
            <p class="admin-import-module__hint">
              {{ 'TRANS__IMPORT__RUN_HINT' | translate }}
            </p>

            @if (store.valueReviewSummary.totals.undecided; as undecided) {
              <p class="admin-import-module__warn admin-import-module__run-undecided">
                @if (undecided === 1) {
                  {{ 'TRANS__IMPORT__VALUE_REVIEW__SKIPPED_AT_RUN_ONE' | translate }}
                } @else {
                  {{ 'TRANS__IMPORT__VALUE_REVIEW__SKIPPED_AT_RUN' | translate: {count: undecided} }}
                }
                <button mat-button type="button" color="primary" (click)="openValueReview.emit()">
                  {{ 'TRANS__IMPORT__VALUE_REVIEW__ENTRY_OPEN' | translate }}
                </button>
              </p>
            }

            <mat-checkbox [formControl]="store.overwriteExistingControl" class="admin-import-module__overwrite">
              {{ 'TRANS__IMPORT__OVERWRITE_EXISTING' | translate }}
            </mat-checkbox>

            <mat-checkbox
              [formControl]="store.publishControl"
              class="admin-import-module__overwrite admin-import-module__publish"
              [matTooltip]="'TRANS__IMPORT__PUBLISH_TOOLTIP' | translate"
              matTooltipPosition="right"
            >
              {{ 'TRANS__MODEL_TITLE__PUBLISH' | translate }}
            </mat-checkbox>

            <div class="admin-import-module__run-range">
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ 'TRANS__IMPORT__RUN_FIRST_ROW' | translate }}</mat-label>
                <input matInput type="number" min="1" [formControl]="store.runFirstRowControl">
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ 'TRANS__IMPORT__RUN_LAST_ROW' | translate }}</mat-label>
                <input matInput type="number" min="1" [formControl]="store.runLastRowControl">
              </mat-form-field>
              <span class="admin-import-module__hint">
                {{ 'TRANS__IMPORT__RUN_ROW_RANGE_HINT' | translate }}
              </span>
            </div>
          </div>

          <div class="admin-import-module__run-outlook">
            <span class="admin-import-module__run-outlook-title">{{ 'TRANS__IMPORT__RUN_OUTLOOK_TITLE' | translate }}</span>
            <ul class="admin-import-module__run-outlook-lines">
              @let preflightOutlook = outlook;
              @if (store.selectedObjectType; as objectType) {
                <li class="admin-import-module__run-outlook-create">
                  <mat-icon aria-hidden="true">add</mat-icon>
                  <span>
                    @if (preflightOutlook) {
                      {{ 'TRANS__IMPORT__RUN_OUTLOOK_CREATE' | translate:
                         {count: preflightOutlook.created, objectType: (objectType.name | translate)} }}
                    } @else if (runRangeRowsText; as count) {
                      {{ 'TRANS__IMPORT__RUN_OUTLOOK_RANGE_ROWS' | translate:
                         {count: count, objectType: (objectType.name | translate)} }}
                    } @else {
                      {{ 'TRANS__IMPORT__RUN_OUTLOOK_CREATE_PER_ROW' | translate:
                         {objectType: (objectType.name | translate)} }}
                    }
                    @if (store.runCollectionLabel; as collection) {
                      {{ 'TRANS__IMPORT__RUN_OUTLOOK_IN_COLLECTION' | translate: {collection: collection} }}
                    }
                  </span>
                </li>
              }
              @if (preflightOutlook) {
                @if (preflightOutlook.skippedRowsTotal) {
                  <li class="admin-import-module__run-outlook-skipped-rows">
                    <mat-icon aria-hidden="true">warning_amber</mat-icon>
                    <span>
                      @if (preflightOutlook.skippedRowsTotal === 1) {
                        {{ 'TRANS__IMPORT__RUN_OUTLOOK_SKIP_ROWS_ONE' | translate }}
                      } @else {
                        {{ 'TRANS__IMPORT__RUN_OUTLOOK_SKIP_ROWS' | translate: {count: preflightOutlook.skippedRowsTotal} }}
                      }
                      @for (skip of preflightOutlook.skippedRows; track skip.reason; let last = $last) {
                        <span class="admin-import-module__run-outlook-skip-reason">{{ rowSkipKeys[skip.reason] | translate: {count: skip.rows} }}{{ last ? '' : ',' }}</span>
                      }
                    </span>
                  </li>
                }
                @for (placement of preflightOutlook.placements; track placement.key) {
                  <li class="admin-import-module__run-outlook-placement">
                    <mat-icon aria-hidden="true">add</mat-icon>
                    <span>
                      {{ 'TRANS__IMPORT__RUN_OUTLOOK_PLACEMENT' | translate:
                         {given: placement.given, title: placement.title ?? ''} }}
                      @if (placement.missing) {
                        {{ 'TRANS__IMPORT__RUN_OUTLOOK_PLACEMENT_MISSING' | translate: {missing: placement.missing} }}
                      }
                    </span>
                  </li>
                }
                @for (field of preflightOutlook.skipped; track $index) {
                  <li class="admin-import-module__run-outlook-skipped">
                    <mat-icon aria-hidden="true">warning_amber</mat-icon>
                    <span>
                      @if (field.rows === 1) {
                        {{ 'TRANS__IMPORT__RUN_OUTLOOK_SKIPPED_ONE' | translate: {label: field.label} }}
                      } @else {
                        {{ 'TRANS__IMPORT__RUN_OUTLOOK_SKIPPED' | translate: {label: field.label, rows: field.rows} }}
                      }
                    </span>
                  </li>
                }
                @if (preflightOutlook.skippedCards) {
                  <li class="admin-import-module__run-outlook-skipped-cards">
                    <mat-icon aria-hidden="true">warning_amber</mat-icon>
                    <span>
                      {{ 'TRANS__IMPORT__RUN_OUTLOOK_SKIP_CARDS' | translate: {count: preflightOutlook.skippedCards} }}
                    </span>
                  </li>
                }
              }
            </ul>
            @if (!store.preflightCoversRunRange) {
              <p class="admin-import-module__hint admin-import-module__run-outlook-partial">
                {{ 'TRANS__IMPORT__RUN_OUTLOOK_NEEDS_PREFLIGHT' | translate }}
              </p>
            }
            @let blockedReason = store.runBlockedReason;
            @if (blockedReason) {
              <p id="import-run-blocked-reason" class="admin-import-module__warn admin-import-module__run-blocked">
                {{ blockedReason | translate }}
              </p>
            }
            <button
              mat-flat-button
              color="primary"
              type="button"
              class="admin-import-module__run"
              [disabled]="!store.canRun"
              [disabledInteractive]="true"
              [attr.aria-describedby]="blockedReason ? 'import-run-blocked-reason' : null"
              (click)="store.run()"
            >
              @if (store.runJob.running) {
                <mat-progress-spinner matButtonIcon mode="indeterminate" diameter="18"></mat-progress-spinner>
              } @else {
                <mat-icon>play_arrow</mat-icon>
              }
              <span class="bold uppercase">{{ 'TRANS__IMPORT__RUN' | translate }}</span>
            </button>
          </div>
        </div>

        @if (store.runJob.running) {
          <div class="admin-import-module__run-progress">
            @if (store.runJob.runProgress !== null) {
              <mat-progress-bar
                mode="determinate"
                [value]="store.runJob.runProgress"
                aria-labelledby="import-run-progress-text"
              ></mat-progress-bar>
              <p id="import-run-progress-text" class="admin-import-module__run-progress-text">
                {{ 'TRANS__IMPORT__RUN_PROGRESS' | translate: {percent: store.runJob.runProgress.toFixed(0)} }}
              </p>
            } @else {
              <mat-progress-bar mode="indeterminate" aria-labelledby="import-run-progress-text"></mat-progress-bar>
              <p id="import-run-progress-text" class="admin-import-module__run-progress-text">
                {{ 'TRANS__IMPORT__RUN_QUEUED' | translate }}
              </p>
            }
          </div>
        }

        @if (store.runJob.runError) {
          <p class="admin-import-module__warn bold">{{ store.runJob.runError }}</p>
        }

        @if (store.runJob.runResult) {
          <app-import-run-result
            [runResult]="store.runJob.runResult"
            [running]="store.runJob.running"
            [adminEventRetryResult]="store.runJob.adminEventRetryResult"
            [mediaJoinColumn]="store.runJob.mediaJoinColumn"
            [fileName]="store.fileName"
            [resolveLabel]="store.resolveConceptLabel"
            [resolveCardTitle]="store.flatOrAdminCardTitle"
            (retryFailedRows)="store.runJob.retryFailedRows()"
            (retryAdminEvents)="store.runJob.retryAdminEvents()"
          ></app-import-run-result>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
